import { render, staticRenderFns } from "./MeetingRoomNotifyTypeField.vue?vue&type=template&id=385f9891&scoped=true"
import script from "./MeetingRoomNotifyTypeField.vue?vue&type=script&lang=js"
export * from "./MeetingRoomNotifyTypeField.vue?vue&type=script&lang=js"
import style0 from "./MeetingRoomNotifyTypeField.vue?vue&type=style&index=0&id=385f9891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f9891",
  null
  
)

export default component.exports